import { useEffect, useState } from 'react';
import DeviceType from 'client/utils/helpers/DeviceType/DeviceType';

const useDeviceType = () => {
    const getDeviceType = () => {
        const width = window.innerWidth;
        if (width) {
            return DeviceType.detect(width);
        }
    };

    const [deviceType, setDeviceType] = useState(getDeviceType());

    const handleDeviceType = () => {
        setDeviceType(getDeviceType());
    };

    useEffect(() => {
        handleDeviceType();
        window.addEventListener('resize', handleDeviceType);
        return () => {
            window.removeEventListener('resize', handleDeviceType);
        };
    }, []);

    return deviceType;
};

export default useDeviceType;
